import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { IMAGES } from '../data/links';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [minutes, setMinutes] = useState(2);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutes(1 + Math.floor(Math.random() * 12));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    nextTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-276" data-mp="116mjj1589497">
      <AnimatePresence data-id="element-277" data-mp="1awzc9gn743qf">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-black/5 bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(23,22,58,0.18)]" data-id="element-278" data-mp="1axhcspgw5445">
            <img src={IMAGES.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-brand-soft object-cover" data-id="element-279" data-mp="28iwlsojlkyq8" />
            <div className="min-w-0" data-id="element-280" data-mp="23l3ettah00ow">
              <p className="text-[14px] leading-snug text-ink" data-id="element-281" data-mp="2aotgq36xhdde">
                <strong data-id="element-282" data-mp="2aqnt2t44vx5v">{buyer.name}</strong> from <strong data-id="element-283" data-mp="2fn4u2nwfm60d">{buyer.country}</strong>
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-284" data-mp="2fpr02j3ocdgh">just purchased the Sensory Modulation Clinical Pathway™</p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-cta-dark" data-id="element-285" data-mp="2plka9vtx7uv3">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-286" data-mp="1rybtge4v79zf" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:bg-black/5 hover:text-ink" aria-label="Dismiss notification" data-id="element-287" data-mp="1wxg5dcj6bltg">
              <XIcon className="h-4 w-4" data-id="element-288" data-mp="197c0z2y5vi1e" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}